//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { EmailTemplateDisplayItem } from './EmailTemplateDisplayItem';
import { MessageTemplatePlaceholder } from './MessageTemplatePlaceholder';
import { EmailTemplateType } from './Enums';

export class SystemEmailTemplateDisplayItem extends EmailTemplateDisplayItem {
    TemplateTypeName: string | null = null;
    TemplateType: EmailTemplateType = EmailTemplateType.Custom;
    Default: EmailTemplateDisplayItem | null = null;
    Placeholders: MessageTemplatePlaceholder[] = [];

    constructor(initializer?: Partial<SystemEmailTemplateDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "SystemEmailTemplateDisplayItem";
}
